"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _aliCDNSuffix = _interopRequireDefault(require("./aliCDNSuffix"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Contain =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Contain, _Component);

  function Contain() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Contain);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Contain)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {};
    return _this;
  }

  (0, _createClass2.default)(Contain, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          alt = _this$props.alt,
          title = _this$props.title,
          src = _this$props.src,
          width = _this$props.width,
          height = _this$props.height,
          _this$props$style = _this$props.style,
          style = _this$props$style === void 0 ? {} : _this$props$style,
          className = _this$props.className,
          onError = _this$props.onError,
          shape = _this$props.shape,
          enableAliCDNSuffix = _this$props.enableAliCDNSuffix,
          errorImgSrc = _this$props.errorImgSrc,
          type = _this$props.type,
          others = (0, _objectWithoutProperties2.default)(_this$props, ["alt", "title", "src", "width", "height", "style", "className", "onError", "shape", "enableAliCDNSuffix", "errorImgSrc", "type"]);

      var styles = _objectSpread({}, style, {
        display: 'inline-block',
        width: width,
        height: height,
        overflow: 'hidden'
      });

      var centerStyles = {
        width: width,
        height: height,
        display: 'table-cell',
        verticalAlign: 'middle',
        textAlign: 'center'
      };
      var imgStyles = {
        width: 'auto',
        height: 'auto',
        maxWidth: width,
        maxHeight: height
      };
      var realSrc = enableAliCDNSuffix ? src + (0, _aliCDNSuffix.default)({
        width: width,
        height: height
      }) : src;
      var cls = (0, _classnames.default)('ice-img', shape, className);
      return _react.default.createElement("div", (0, _extends2.default)({
        className: cls,
        style: styles
      }, others), _react.default.createElement("div", {
        style: centerStyles
      }, _react.default.createElement("img", {
        style: imgStyles,
        onError: onError,
        ref: "img",
        src: realSrc,
        alt: alt,
        title: title
      })));
    }
  }]);
  return Contain;
}(_react.Component);

exports.default = Contain;
Contain.displayName = 'Contain';
Contain.propTypes = {
  src: _propTypes.default.string.isRequired,
  width: _propTypes.default.number,
  height: _propTypes.default.number,
  alt: _propTypes.default.string,
  onError: _propTypes.default.func,
  style: _propTypes.default.object,
  shape: _propTypes.default.string
};
Contain.defaultProps = {
  onError: function onError() {},
  alt: ''
};